// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"Orders_PageHolder__cRQyQ","tabHolder":"Orders_tabHolder__2Ydjc","onFocus":"Orders_onFocus__3wY35"};